import React from 'react';
import type { SearchDataResponse } from '@/shared/api/sockets/modules/search';
import { Loader } from '@/shared/ui/loader';
import { EmptySearch } from './EmptySearch';
import { SearchContent } from './SearchContent';
interface Props {
  isEmptySearch: boolean;
  isLoading: boolean;
  loadNewPage: boolean;
  searchResults: SearchDataResponse<['doctors', 'medcenters', 'skills']> | null;
  cityAlias: string;
  setLoadNewPage: (value: boolean) => void;
}
export const SearchContentWrapper: React.FC<Props> = ({
  isEmptySearch,
  isLoading,
  loadNewPage,
  searchResults,
  cityAlias,
  setLoadNewPage
}) => {
  return <>
      {isEmptySearch && <EmptySearch />}

      {loadNewPage && <>
          <div className="bg-opacity/50 absolute left-0 top-0 size-full bg-white" />

          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <Loader size="4xl" />
          </div>
        </>}

      {!isEmptySearch && isLoading && <div className="flex h-full flex-col items-center justify-center">
          <Loader size="lg" />
        </div>}

      {!isEmptySearch && !isLoading && <SearchContent skills={searchResults?.skills?.data || []} doctors={searchResults?.doctors?.data || []} medcenters={searchResults?.medcenters?.data || []} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} />}
    </>;
};